// extracted by mini-css-extract-plugin
module.exports = {"root":"Icon_root__FqxM_","withoutFill":"Icon_withoutFill__4GGBZ"};